import { render, staticRenderFns } from "./GradesCalculator.vue?vue&type=template&id=64d5f49a&scoped=true"
import script from "./GradesCalculator.vue?vue&type=script&lang=js"
export * from "./GradesCalculator.vue?vue&type=script&lang=js"
import style0 from "./GradesCalculator.vue?vue&type=style&index=0&id=64d5f49a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d5f49a",
  null
  
)

export default component.exports